export default "__VITE_ASSET__po0Md2ms__"